import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StaticPageFooterComponent } from './static-page-footer.component';
import { ButtonModule } from '../button/button.module';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [
    StaticPageFooterComponent,
  ],
  imports: [
    CommonModule,
    ButtonModule,
    TranslateModule,
    RouterModule,
  ],
  exports: [
    StaticPageFooterComponent,
  ],
  providers: [
    TranslatePipe,
  ],
})
export class StaticPageFooterModule { }
